module.exports = "/_next/static/images/search_bg_27-f17d0d8cf9c7612bc65031455d63cc31.jpg";